import {pxToRem} from '../../../../../utills/pxToRem'

export const getApplePayStyle = (isMiniCart) => {
    const paddingY = pxToRem(isMiniCart ? 10 : 8)
    const paddingX = pxToRem(20)
    return {
        '.adyen-checkout__applepay__button': {
            mt: 1, // cleaner than '0.5rem'
            width: isMiniCart ? '90% !important' : '100%',
            height: pxToRem(40),
            borderRadius: 0,
            padding: `${paddingY} ${paddingX} !important`,
            '-webkit-appearance': '-apple-pay-button !important',
            appearance: '-apple-pay-button !important'
        }
    }
}
